import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService, ReportService, SalesService} from '@app/shared/services';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of, firstValueFrom} from 'rxjs';
import {CommonModule, DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {routerTransition} from '@app/router.animations';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {environment} from '@env/environment';
import {UtilsInjectable} from '@app/shared';
import numberToWords from 'number-to-words';

@Component({
  selector: 'app-add-sale',
  templateUrl: './add-sale.component.html',
  styleUrls: ['./add-sale.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    NgbHighlight,
    SelectDropDownModule,
    NgbTypeahead
  ],
  providers: [DatePipe]
})
export class AddSaleComponent implements OnInit {
  user_rights: any;
  user_data: any;

  public now = new Date();

  warehouse_choose_data: any
  public sale_details: any = [""];
  public sale: any =
    {
      sale_id: 0,
      patient_name: '',
      payment_type: [],
      bill_type: 1,
      patient_no: '',
      customer: '',
      doctor: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      order_no: '',
      vat_no: '',
      slab: 3,
      cardno: '',
      chequeno: '',
      remark: "",
      customer_address: "",
      shipping_address: "",
      medicine_id_arr: [""],
      base_price: [""],
      slab_per: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      medicine_data: [],
      price_arr: [""],
      flood_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      warehouse_arr: [""],
      unitprice_arr: [""],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_details_id_arr: [""],
      mark_free_of_cost: [false],
      upload_file: [],
      removeUpload: [],
      warehouses_data: [],
      crd_note_id:0,
      grand_tot:0,
      card_amount:0,
      cheque_amount:0,
      credit_note_amount:0,
      cash_amount:0,
      bank_amount:0
    }
  searching = false;
  searchFailed = false;
  date: any;
  unit: any;

  total_amount = 0;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  saled: any;
  item_list: any;
  price_total = 0;

  item: any;
  gross = 0;
  net_total = 0;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  numberToWords: any;
  customer: any;
  customer_options: any;
  customer_data: any;
  filelist: any;
  fileName: any = [];
  warehouses_data: any = [];
  creditnote_options:any;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private salesService: SalesService,
    private consultingService: ConsultingService,
    private toastr: ToastrService,
    protected utils: UtilsInjectable) {

  }

  ngOnInit() {
    this.listCustomer();
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.route.params.subscribe(params => {
      this.sale.sale_id = Number.parseInt(params['sale_id']);
      this.listCustomer();
    });
    const id = +(this.route.snapshot.paramMap.get('id') || "");
    if (id != null && id != 0) {
      this.sale.sale_id = id;

      this.getSale(this.sale.sale_id);
    } else {
      this.listCustomer();
    }

    if (!this.sale) this.sale = {};
    if (!Array.isArray(this.sale.payment_type)) {
      this.sale.payment_type = [];
    }
  }

  public attachmentPath(filename: any) {
    return environment.SALE_UPLOAD_PATH + filename;
  }

  public giveMarkFOC(index: any) {

    if (this.sale.mark_free_of_cost[index] == true) {
      this.sale.mark_free_of_cost[index] = true
      this.sale.vatamt_arr[index] = 0;
      this.sale.unitprice_arr[index] = 0;
      this.sale.base_price[index] = 0;
      this.sale.flood_arr[index] = 0;
      this.sale.total_arr[index] = 0;
      this.sale.price_arr[index] = 0;
      this.totalAmount();
      this.totalprice();
      this.total();
    }
    this.sale.mark_free_of_cost.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
    });
  }

  public getSale(sale_id: any) {
    this.cleardata();
    this.clear_sale();
    const postData = {
      sale_id: sale_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        this.sale_details = ['0'];
        const sale_details = [];
        this.sale.patient_name = this.saled.PATIENT_NAME;
        this.sale.order_no = this.saled.INVOICE_NUMBER;
        this.sale.sale_date = this.saled.SALE_DATE;
        this.sale.chequeno = this.saled.CHEQUE_CARD_NUMBER;
        this.sale.cardno = this.saled.CARD_NUMBER;
        this.sale.sale_id = this.saled.SALE_ID;
        this.sale.vat_no = this.saled.VAT_NO;
        this.sale.remark = this.saled.ONLINE_REMARK;
        this.sale.shipping_address = this.saled.SHIPPING_ADDRESS;

        if(this.saled.PAYMENT_TYPE_CASH == 1){
          this.sale.payment_type.push(1);
          this.sale.cash_amount = this.saled.CASH_AMOUNT;
        }
        if(this.saled.PAYMENT_TYPE_CARD == 1){
          this.sale.payment_type.push(0);
          this.sale.card_amount = this.saled.CARD_AMOUNT;
        }
        if(this.saled.PAYMENT_TYPE_CHEQUE == 1){      
          this.sale.payment_type.push(2);
          this.sale.cheque_amount = this.saled.CHEQUE_AMOUNT;
        }
        if(this.saled.PAYMENT_TYPE_BANK == 1){
          this.sale.payment_type.push(3);
          this.sale.bank_amount = this.saled.BANK_AMOUNT;
        }
        if(this.saled.PAYMENT_TYPE_CREDIT_NOTE == 1){
          this.sale.payment_type.push(4);
          this.sale.credit_note_amount = this.saled.CREDIT_NOTE_AMOUNT;
        }
        this.sale.freight_charge = this.saled.FREIGHT_CHARGE;
        this.sale.discount = this.saled.DISCOUNT;
        this.sale.credit_note_no = this.saled.CN_NO;
        this.sale.crd_note_id = this.saled.CREDIT_NOTE
        if (this.sale.vat_no) {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        } else {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        }
        for (const val of result['data'].SALE) {
          sale_details.push(i);
          this.sale.medicine_data[i] = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
            'DDC_CODE': val.DDC_CODE,
            'SCIENTIFIC_CODE': val.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': val.SCIENTIFIC_NAME
          };
          this.sale.product_arr[i] = val.PRODUCT_CODE;
          this.sale.quantity_arr[i] = val.QUANTITY;
          this.sale.uom_arr[i] = val.UNIT_ID;
          this.sale.uom_arr_name[i] = val.UNIT_DESC;
          this.sale.MRP[i] = val.MRP;
          this.sale.purchase_details_id_arr[i] = val.PURCHASE_DETAILS_ID
          this.sale.mark_free_of_cost[i] = val.MARK_FOC
          this.sale.medicine_id_arr[i] = val.MEDICINE_ID

          this.sale.vat_arr[i] = val.VAT;
          this.sale.vatamt_arr[i] = val.VAT_AMOUNT;
     
          if (val.WAREHOSE_AVAILABLE_QUANTITY == "" || val.WAREHOSE_AVAILABLE_QUANTITY == null) {
            this.sale.ava_quantity_arr[i] = val.AVAILABLE_STOCK_QUANTITY;
          } else {
            this.sale.ava_quantity_arr[i] = val.WAREHOSE_AVAILABLE_QUANTITY;
          }
          this.sale.warehouse_arr[i] = val.WAREHOUSE_NAME;
          this.sale.warehouse_details_id_arr[i] = val.WAREHOUSE_STOCK_DETAIL_ID;
          this.sale.total_arr[i] = val.TOTAL
          this.sale.mark_free_of_cost[i] = val.MARK_FOC == 1;
          this.sale.unitprice_arr[i] = parseFloat(val.TOTAL) / parseInt(val.QUANTITY)
          i = i + 1;
        }
        this.sale_details = sale_details;
        this.filelist = result['data'].ATTACHMENTS;
        this.total();
        this.totalAmount();
        this.getSum();
        this.totalprice();
        this.setCustomer();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public async Updatesale(): Promise<any> {
    this.sale.user_id = this.user_data.user_id
    this.sale.date = this.utils.date(this.sale.date)
    let rep = 0;

    if(!this.sale.payment_type){
      this.toastr.error('Please select payment type');
      return false;
    }
    if(!this.sale.patient_name){
        this.toastr.error('Please select customer');
        return false;
    }
    if(this.sale.payment_type?.includes(0)){
      if(!Number(this.sale.cardno)){
        this.toastr.error('Please enter card number');
        return false;
      }
      if(!Number(this.sale.card_amount)){
        this.toastr.error('Please enter card amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(1)){
      if(!Number(this.sale.cash_amount)){
        this.toastr.error('Please enter cash amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(2)){
      if(!Number(this.sale.chequeno)){
        this.toastr.error('Please enter cheque number');
        return false;
      }
      if(!Number(this.sale.cheque_amount)){
        this.toastr.error('Please enter cheque amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(3)){
      if(!Number(this.sale.bank_amount)){
        this.toastr.error('Please enter bank amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(4)){
      if (!Number(this.sale.crd_note_id)) {
        this.toastr.error('Please select credit note');
        return false;
      }
    }
    
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      let vat;
      let mrp = 0;
      if (this.sale.mark_free_of_cost[index] == false && this.sale.unitprice_arr[index] == 0) {
        this.toastr.error('Please mark the FOC or enter the retail price')
        rep = 1;
        return false;
      }

      // if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
      //   this.toastr.error('Retail price should be less than or equal to MRP price');
      //   rep = 1;
      // }
      if (this.sale.quantity_arr[index] == "" || this.sale.quantity_arr[index] == 0) {
        this.toastr.error('Enter quantity');
        rep = 1;
        return false;
      }
    });

    let adj_tot =
      Number(this.sale.cash_amount || 0) +
      Number(this.sale.card_amount || 0) +
      Number(this.sale.cheque_amount || 0) +
      Number(this.sale.bank_amount || 0) +
      Number(this.sale.credit_note_amount || 0);

    if(adj_tot != this.sale.grand_tot){
        this.toastr.error('Grand total and payment type total must be equal');
        return false;
    }

    if (rep == 0) {
      this.total(); 

      this.sale.gross_total = this.total_amount || 0;
      this.sale.net_total = this.net_total || 0;

      this.loaderService.display(true);
      this.reportService.Updatesale(this.sale).subscribe((result: any) => {
        // this.loaderService.display(true);
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result.msg);
          this.router.navigate(['sale/sale-list']).then();
        } else {
          this.toastr.error(result.msg);
          this.loaderService.display(false);
        }
      })
    }

  }

  public warehouselist(item_id: any, i: any) {
    const postData = {
      medicine_id: item_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.warehouselist(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale.warehouses_data[i] = result['data'];
        this.loaderService.display(false);
      } else {
        this.toastr.error('No available wareouses');
        this.loaderService.display(false);
      }
    });
  }

  public cleardata() {
    this.warehouse_choose_data = []
    this.sale.medicine_id_arr = [""]
    this.sale.slab_per = [""]
    this.sale.base_price = [""]
    this.sale.ava_quantity_arr = [""]
    this.sale.quantity_arr = ["1"]
    this.sale.uom_arr = [""]
    this.sale.uom_arr_name = [""]
    this.sale.amount_arr = [""]
    this.sale.medicine_data = []
    this.sale.flood_arr = [""]
    this.sale.price_arr = [""]
    this.sale.MRP = [""]
    this.sale.dis_arr = [""]
    this.sale.user_id = ''
    this.sale.total_arr = [""]
    this.sale.unitprice_arr = [""]
    this.sale.product_arr = [""]
    this.sale.vat_arr = [""]
    this.sale.vatamt_arr = [""]
    this.sale.purchase_details_id_arr = [""]
    this.sale.mark_free_of_cost = [false]
    this.sale.upload_file = []
    this.sale.removeUpload = []
    this.sale.warehouses_data = []
    this.fileName = [],
    this.sale.grand_tot = 0,
    this.sale.card_amount = 0,
    this.sale.cheque_amount = 0,
    this.sale.credit_note_amount = 0,
    this.sale.cash_amount = 0
    this.sale.bank_amount = 0
  }

  public availableqty(i: any) {

    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    const postData = {
      medicine_id: this.sale.medicine_id_arr[i],
      warehouse_details_id: this.sale.warehouse_details_id_arr[i],
    };
    this.loaderService.display(true);
    this.reportService.detailedlist(postData).subscribe((result: any) => {

      this.loaderService.display(false);
      if (result["status"] == "Success") {
        const item_data = result["data"]
        this.sale.medicine_id_arr[i] = item_data.MEDICINE_ID;
        this.sale.warehouse_arr[i] = item_data.WAREHOUSE_ID;
        this.sale.product_arr[i] = item_data.PRODUCT_CODE;
        this.sale.uom_arr[i] = item_data.UNIT_ID;
        this.sale.uom_arr_name[i] = item_data.UNIT_DESC;
        this.sale.MRP[i] = item_data.MRP;
        this.sale.warehouse_details_id_arr[i] = item_data.WAREHOUSE_STOCK_DETAIL_ID;

        this.sale.vat_arr[i] = item_data.VAT;

        if (item_data.WAREHOSE_AVAILABLE_QUANTITY > 0) {
          this.sale.ava_quantity_arr[i] = item_data.WAREHOSE_AVAILABLE_QUANTITY;
        } else {
          this.sale.ava_quantity_arr[i] = 0;
        }
        this.sale.purchase_details_id_arr[i] = item_data.PURCHASE_DETAILS_ID;
        const vat = parseFloat(this.sale.vat_arr[i]);

        if (this.sale.slab) {
          if (this.sale.slab == 1) {
            this.sale.unitprice_arr[i] = item_data.SLAB_A_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_A;
          }
          if (this.sale.slab == 2) {
            this.sale.unitprice_arr[i] = item_data.SLAB_B_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_B;
          }
          if (this.sale.slab == 3) {
            this.sale.slab_per[i] = item_data.SLAB_C;
            this.sale.unitprice_arr[i] = item_data.SLAB_C_AMOUNT;
          }
        } else {
          this.sale.unitprice_arr[i] = item_data.MRP;
        }
        const unit = parseFloat(this.sale.unitprice_arr[i]);
        this.sale.base_price[i] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100);
        this.sale.flood_arr[i] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100);
        this.totalprice();
        this.totalAmount();
      } else {
        this.toastr.error('No available warehouses');
        this.loaderService.display(false);
      }
    })


  }

  public set_item_medicine($event: any, i: any): any {
    if (this.sale.patient_name == "") {
      this.toastr.error('Please select customer !')
      return false;
    }
    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    this.sale.slab_per[i] = ''
    this.sale.base_price[i] = ''
    this.sale.ava_quantity_arr[i] = ''
    this.sale.uom_arr[i] = ''
    this.sale.uom_arr_name[i] = ''
    this.sale.amount_arr[i] = ''
    this.sale.medicine_data[i] = ''
    this.sale.flood_arr[i] = ''
    this.sale.user_id = ''
    this.sale.unitprice_arr[i] = ''
    this.sale.product_arr[i] = ''
    this.sale.vat_arr[i] = ''
    this.sale.vatamt_arr[i] = ''
    this.sale.warehouse_arr[i] = ''
    this.sale.warehouse_details_id_arr[i] = ''
    this.sale.purchase_details_id_arr[i] = ''
    this.sale.warehouses_data[i] = [""]
    const item = $event.item;
    this.sale.medicine_id_arr[i] = item.MEDICINE_ID
    this.warehouselist(item.MEDICINE_ID, i);
  }

  public clear_sale() {
    this.customer_data = ""
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.net_total = 0;
    this.sale = {
      sale_id: 0,
      warehouses_data: [],
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      doctor: '',
      customer: '',
      sale_date: new Date(),
      discount: 0,
      net_total: 0,
      freight_charge: 0,
      disc_per: 0,
      customer_address: "",
      order_no: '',
      vat_no: '',
      slab: 3,
      cardno: '',
      chequeno: '',
      remark: '',
      shipping_address: '',
      medicine_data: [],
      slab_per: [""],
      flood_arr: [""],
      base_price: [""],
      medicine_id_arr: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      warehouse_arr: [""],
      warehouse_details_id_arr: [""],
      unitprice_arr: [''],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      mark_free_of_cost: [false],
      upload_file: [],
      removeUpload: [],
      grand_tot:0,
      card_amount:0,
      cash_amount:0,
      bank_amount:0
    }
    this.fileName = []
  }

  public totalprice() {
    let sum = 0;


    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      let mrp = 0;
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (this.sale.sale_id == 0) {
        if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
          this.toastr.error('Invalid quantity');
          return false;
        }
      }

      // if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
      //   this.toastr.error('Retail price should be less than or equal to MRP price');
      //   return false;
      // } else {
        if (parseInt(this.sale.quantity_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
          const qty = parseInt(this.sale.quantity_arr[index]);
          const base_price = parseFloat(this.sale.base_price[index]);
          if (!isNaN(qty)) {

            sum = qty * base_price;

          } else {
            sum = 0;
          }
          this.sale.price_arr[index] = sum;
        }
      // }

    });

  }

  public totalAmount() {
    let sum = 0
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (parseInt(this.sale.quantity_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
        const unit = parseFloat(this.sale.unitprice_arr[index]);
        const vat = parseFloat(this.sale.vat_arr[index]);
        const qty = parseInt(this.sale.quantity_arr[index])

        this.sale.base_price[index] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100);
        const base_price = parseFloat(this.sale.base_price[index])
        const flood = (base_price * (environment.FLOOD_CESS_PERCENTAGE / 100));
        this.sale.flood_arr[index] = flood * qty;
        const price = parseFloat(this.sale.price_arr[index]);
        const slab_price = parseFloat(this.sale.unitprice_arr[index]);

        if (!isNaN(price)) {
          sum = price;
        }

        if (!isNaN(vat && base_price)) {
          this.sale.vatamt_arr[index] = ((base_price * (vat / 100)) * qty);
        }
   
        if (!isNaN(slab_price && qty)) {
          sum = slab_price * qty
        }
        this.sale.total_arr[index] = sum;
        this.total();
      }

      this.grandTot(index);
    });
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public total() {
    let sum = 0;
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      const total = parseFloat(this.sale.total_arr[index]);
      if (!isNaN(total)) {
        sum = sum + total
      }

    });
    this.total_amount = sum;
    const freight_charge = parseFloat(this.sale.freight_charge);
    const discount = parseFloat(this.sale.discount);
    if (discount > 0 && this.total_amount && freight_charge == 0) {
      this.net_total = 0;
      this.net_total = Math.round(this.total_amount - discount);
    } else if (freight_charge > 0 && this.total_amount && discount == 0) {

      this.net_total = Math.round((this.total_amount + freight_charge));
    } else if (freight_charge > 0 && this.total_amount && discount > 0) {
      this.net_total = Math.round((this.total_amount + freight_charge) - discount);
    } else {
      this.net_total = Math.round(this.total_amount);
    }

  }

  public async saveSale(): Promise<any> {
    if(!this.sale.payment_type){
      this.toastr.error('Please select payment type');
      return false;
    }
    if(!this.sale.patient_name){
        this.toastr.error('Please select customer');
        return false;
    }
    if(this.sale.payment_type?.includes(0)){
      if(!Number(this.sale.cardno)){
        this.toastr.error('Please enter card number');
        return false;
      }
      if(!Number(this.sale.card_amount)){
        this.toastr.error('Please enter card amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(1)){
      if(!Number(this.sale.cash_amount)){
        this.toastr.error('Please enter cash amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(2)){
      if(!Number(this.sale.chequeno)){
        this.toastr.error('Please enter cheque number');
        return false;
      }
      if(!Number(this.sale.cheque_amount)){
        this.toastr.error('Please enter cheque amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(3)){
      if(!Number(this.sale.bank_amount)){
        this.toastr.error('Please enter bank amount');
        return false;
      }
    }

    if(this.sale.payment_type?.includes(4)){
      if (!Number(this.sale.crd_note_id)) {
        this.toastr.error('Please select credit note');
        return false;
      }
    }

    let rel = 1;
    let stock_arr: any[] = [];
    this.sale.medicine_id_arr.forEach((_item: any, index: any): any => {
      let mrp = 0;
      stock_arr.push(this.sale.warehouse_details_id_arr[index]);
      if (this.sale.mark_free_of_cost[index] == false && this.sale.unitprice_arr[index] == 0) {
        this.toastr.error('Please mark the FOC or enter the retail price')
        rel = 0;
        return false;
      }
      if (this.sale.warehouse_details_id_arr[index] == false && this.sale.unitprice_arr[index] == 0) {
        this.toastr.error('Please mark the FOC or enter the retail price')
        rel = 0;
        return false;
      }
      if (this.sale.quantity_arr[index] == "" || this.sale.quantity_arr[index] == 0) {
        this.toastr.error('Enter quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
        this.toastr.error('Invalid quantity');
        rel = 0;
        return false;
      }

      // if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
      //   this.toastr.error('Retail price should be less than or equal to MRP price');
      //   rel = 0;
      //   return false;
      // }

    });

      let adj_tot =
      Number(this.sale.cash_amount || 0) +
      Number(this.sale.card_amount || 0) +
      Number(this.sale.cheque_amount || 0) +
      Number(this.sale.bank_amount || 0) +
      Number(this.sale.credit_note_amount || 0);

    if(adj_tot != this.sale.grand_tot){
        this.toastr.error('Grand total and payment type total must be equal');
        return false;
    }

    if (rel == 0) {
      return false
    }
    const data = this.checkSameWarehouse(stock_arr);
    if (data > -1) {
      this.toastr.error("Duplicate warehouse is found on " + this.sale.medicine_data[data].TRADE_NAME)
      stock_arr = []
      return false
    }
    this.sale.user_id = this.user_data.user_id
    this.sale.date = this.utils.date(this.sale.date)
    this.total();

    this.sale.gross_total = this.total_amount || 0; 
    this.sale.net_total = this.net_total || 0;      

    this.loaderService.display(true);
    this.reportService.saveSale(this.sale).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success( result.msg);
        this.sale.sale_id = result.data_id;
        this.sale_items();
        this.listCustomer();
        this.clear_sale();
        this.router.navigate(['sale/sale-list']).then();

      } else {
        this.toastr.error( result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public checkSameWarehouse(stock_arr: any) {
    for (let i = 0; i < stock_arr.length; i++) {
      for (let j = 0; j < stock_arr.length; j++) {
        if (i != j) {
          if (stock_arr[i] == stock_arr[j]) {
            return i;
          }
        }
      }
    }
    return -1;
  }

  public addrow(index: any) {
    this.sale_details[index + 1] = '';
    this.sale.medicine_data[index + 1] = '';
    this.sale.uom_arr_name[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.total_arr[index + 1] = '';
    this.sale.unitprice_arr[index + 1] = '';
    this.sale.quantity_arr[index + 1] = '1';
    this.sale.ava_quantity_arr[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.purchase_details_id_arr[index + 1] = '';
    this.sale.mark_free_of_cost[index + 1] = false;
    this.sale.product_arr[index + 1] = '';
    this.sale.vat_arr[index + 1] = '';
    this.sale.vatamt_arr[index + 1] = '';
    this.sale.warehouse_arr[index + 1] = '';
    this.sale.warehouse_details_id_arr[index + 1] = '';
  }

  public deleterow(index: any) {
    this.sale_details.splice(index, 1);
    this.sale.medicine_data.splice(index, 1);
    this.sale.medicine_id_arr.splice(index, 1);
    this.sale.quantity_arr.splice(index, 1);
    this.sale.uom_arr_name.splice(index, 1);
    this.sale.amount_arr.splice(index, 1);
    this.sale.price_arr.splice(index, 1);
    this.sale.dis_arr.splice(index, 1);
    this.sale.total_arr.splice(index, 1);
    this.sale.unitprice_arr.splice(index, 1);
    this.sale.ava_quantity_arr.splice(index, 1);
    this.sale.purchase_details_id_arr.splice(index, 1);
    this.sale.mark_free_of_cost.splice(index, 1);
    this.sale.product_arr.splice(index, 1);
    this.sale.vat_arr.splice(index, 1);
    this.sale.vatamt_arr.splice(index, 1);
    this.sale.warehouse_arr.splice(index, 1);
    this.sale.warehouse_details_id_arr.splice(index, 1);
    this.sale.warehouses_data.splice(index, 1);
    this.total();
  }

  public sale_items() {
    const postData = {

      sale_id: this.sale.sale_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        this.getSum();
      }
      this.loaderService.display(false);
    });
  }

  getSum() {
    let total = 0;

    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
    }
    this.gross = total
    if (this.saled) {
      this.price_total = Math.round(this.gross - this.saled.DISCOUNT)
    } else {
      this.price_total = Math.round(this.gross)
    }


    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public selectCoinPaymentType(val: number, event: any) {
    if (!this.sale) {
      this.sale = { payment_type: [] };
    }
    if (!Array.isArray(this.sale.payment_type)) {
      this.sale.payment_type = [];
    }

    if (event.target.checked) {
      if (!this.sale.payment_type.includes(val)) {
        this.sale.payment_type.push(val);
      }
    } else {
      this.sale.payment_type = this.sale.payment_type.filter((t: number) => t !== val);
    }

  }



  removeFile(id: any) {
    this.sale.removeUpload.push(id);
  }

  selectFiles($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      const filesAmount = $event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName.push($event.target.files[i])
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const image = event.target.result;
          const splitted = image.split(",");
          this.sale.upload_file.push(splitted[1]);
        }
        reader.readAsDataURL($event.target.files[i]);
      }

    }
  }

  public listCustomer() {
    this.customer = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listCustomer().subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.customer = result['data'];
        this.customer_options = this.customer;
        this.sale.order_no = result['invoice_no']['data']
        this.setCustomer(); 
      } 
      this.loaderService.display(false);
    });
  }

  public setCustomer() {
    if (this.sale.patient_name) {
      for (let index = 0; index < this.customer.length; index++) {
        if (this.customer[index].CUSTOMER_ID == this.sale.patient_name) {
          this.customer_data = this.customer[index];
          break;
        }
      }
    }
  }

  getCustomer() {
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.net_total = 0;
    this.sale = {
      sale_id: 0,
      patient_name: '',
      payment_type: [],
      bill_type: 1,
      patient_no: '',
      doctor: '',
      customer: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      customer_address: "",
      order_no: this.sale.order_no,
      vat_no: '',
      slab: 3,
      cardno: '',
      chequeno: '',
      remark: '',
      shipping_address: '',
      medicine_data: [],
      slab_per: [""],
      flood_arr: [""],
      base_price: [""],
      medicine_id_arr: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      warehouse_arr: [""],
      warehouse_details_id_arr: [""],
      unitprice_arr: [''],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      mark_free_of_cost: [false],
      upload_file: [],
      removeUpload: [],
      warehouses_data: []
    }
    this.fileName = []

    this.sale.patient_name = this.customer_data.CUSTOMER_ID;
    this.sale.vat_no = this.customer_data.VAT_NO;
    this.sale.customer_address = this.customer_data.CUSTOMER_ADDRESS;

    if (this.sale.vat_no) {
      environment.FLOOD_CESS_PERCENTAGE = 0;
    } else {
      environment.FLOOD_CESS_PERCENTAGE = 0;
    }
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.salesService.medicine_search(term)
          .pipe(
            map((response: any) => {
              if (response.status == 'Success') {
                return response.data;
              } else {
                return [];
              }
            }),
            catchError(() => of([]))
          )
      ),
      tap(() => this.searching = false)
    );

  formatter = (x: any): any => x.TRADE_NAME;

  public async checkCreditNote(): Promise<boolean> {
    if(!this.sale.patient_name){
      this.toastr.error('Please select customer');
      return false;
    }
    if(!this.sale.payment_type?.includes(4)){
      this.sale.credit_note_amount = 0;
      this.creditnote_options = [];
      this.sale.credit_note_no = 0;
      return false;
    }
    const result: any = await firstValueFrom(
      this.reportService.checkCreditNote({ customer: this.sale.patient_name })
    );
    this.creditnote_options = result["data"];

    return true; 
  }

  setCreditNote(data: any){
    this.sale.crd_note_id = data.value.CN_ID;
    this.sale.credit_note_amount = data.value.total;
  }

  grandTot(i: any) {
    let total_amt = 0;

    for (let index = 0; index <= i; index++) {
      total_amt += Number(this.sale.total_arr[index]) || 0;
    }

    this.sale.grand_tot = total_amt;
  }

}